# Preload images and audio files using ajax to not block the UI thread

#Logger = new (require "lib/logger")(true, "PRELOADER", "#2FA8E3")
Logger = (args...) -> console.log args...

types =
  image: [ "png", "jpg", "jpeg", "gif", "svg" ]
  video: [ "mp4", "mpeg", "m4v" ]
  audio: [ "wav", "mp3" ]

regexs = []
for type, extensions of types
  regexs[type] = new RegExp(".(#{extensions.join('|')})$", 'i')

# Handle unsplash image library urls which do not end with file extensions
regexs["unsplash"] = new RegExp("images\\.unsplash\\.com", 'i')

isAsset = (asset, type) -> asset?.match?(regexs[type])

class MediaElement
  constructor: ->
    @image = new Image()
    @audio = new Audio()
    @src   = null
    @type  = null

  onload: ->
  onerror: ->
  remove: ->

  setSrc: (url) ->
    @src = url
    if url.match(regexs.image) || url.match(regexs.unsplash)
      @type = "image"
      @image.src = url
      @image.onload =  => @onload()
      @image.onerror = => @onerror()
    else if url.match(regexs.audio)
      @type = "audio"
      $.ajax
        url: url
        type: "GET"
        success: => @onload()
        error: => @onerror()

    else
      console.error("Unrecognized type")

  getSrc:  -> @src
  getType: -> @type
  getContent: -> @image or @audio


load = (all = [], callback, conc = 4, maxTime = 3000) ->
  return callback?() if all.length is 0
  all = _.compact(all)
  return callback?() if all.length is 0

  count   = 0
  errors  = []
  cancel  = false
  start   = Date.now()
  total   = all.length

  mediaEls  = (new MediaElement() for i in [0...conc])
  grouped = _.groupBy all, (e, i, arr) -> Math.floor(i / arr.length * conc)

  Logger("loading #{all.length} media element(s)")

  onComplete = ->
    window.clearTimeout(timeout)
    return if !mediaEls or mediaEls.length is 0

    cancel    = true
    duration  = Date.now() - start
    isSuccess = (el) -> !!el and el.getSrc() and errors.indexOf(el.getSrc()) is -1
    images = for el in mediaEls when isSuccess(el) and el.getType() is "image"
      el.getContent()
    callback?(errors, images)

    Logger "loaded #{count}/#{total} media element(s) in #{duration}ms"

    for elt in mediaEls
      elt.remove()

    mediaEls = null

  for i, elements of grouped
    do (elements, i) ->
      mediaEl = mediaEls[i]

      onLoad = (elt, err) ->
        count++ unless err

        onComplete() if count is all.length
        loadNext()   if elements.length > 0 and not cancel

      onError = (elt) ->
        errors.push elt.getSrc()
        Logger "✕ error loading #{elt.getSrc()}"
        onLoad(elt, true)

      loadNext = ->
        mediaEl.setSrc(elements.shift())

      mediaEl.onload =  -> onLoad(this)
      mediaEl.onerror = -> onError(this)

      loadNext()

  timeout = window.setTimeout (-> onComplete()), maxTime

###
  Look through each stylesheet and collect any images that match the regEx,
  and sends the these to the load method when ready.
###

preloadThomasAssets = ->
  images = [
    "img/templates/loader-light.gif",
    "img/templates/loader.gif",
    "img/templates/star-default.png",
    "img/templates/star-earned.png",
    "img/templates/star-light.png",
    "img/video/empty.png",
    "img/expand-browser.png",
    "img/rotate-device.png"
  ]
  @load images

preloadLessonAssets = (slides) ->
  recur = (obj, method) ->
    if obj and Array.isArray(obj)
      return obj.map (t) -> recur(t, method)
    else if (obj and typeof obj is "object")
      result = {}
      Object.keys(obj).forEach (k) ->
        result[k] = recur(obj[k], method)
      return result
    else
      return method(obj)

  lessonAssets =  []
  captureAssets = (s) -> recur s, (p) ->
    lessonAssets.push(p) if isAsset(p, "audio") or isAsset(p, "image")

  captureAssets(slide) for slide in slides
  Logger("lessonAssets", lessonAssets)
  onLessonAssetsLoaded = ->
  load(lessonAssets, onLessonAssetsLoaded, 4, 40000)

module.exports = {  load, preloadThomasAssets, preloadLessonAssets }
